import { render } from "./VacancyLinkCard.vue?vue&type=template&id=7a7e694e&scoped=true"
import script from "./VacancyLinkCard.vue?vue&type=script&lang=js"
export * from "./VacancyLinkCard.vue?vue&type=script&lang=js"

import "./VacancyLinkCard.vue?vue&type=style&index=0&id=7a7e694e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7e694e"]])

export default __exports__